<template>
  <div :class="$style.wrapper">
    <header :class="$style.header">
      <div>
        <p :class="$style.headerLabel">Документация</p>
        <h1>Правила платформы SNKRROOM</h1>
      </div>
    </header>

    <section :class="$style.meta">
      <p>
        Правила пользования профессиональной информационной ресейл-платформой
        «SNKRROOM».
      </p>
      <p>
        Актуальная версия Правил находится в разделе «Документация» в личном
        кабинете Участника.
      </p>
    </section>

    <article :class="$style.article">
      <section
        v-for="section in sections"
        :key="section.title"
        :class="$style.section"
      >
        <h2>{{ section.title }}</h2>
        <p v-if="section.subtitle" :class="$style.subtitle">
          {{ section.subtitle }}
        </p>
        <template v-if="section.paragraphs">
          <p v-for="(paragraph, idx) in section.paragraphs" :key="`p-${idx}`">
            {{ paragraph }}
          </p>
        </template>
        <ul v-if="section.list?.length">
          <li v-for="(item, idx) in section.list" :key="`li-${idx}`">
            {{ item }}
          </li>
        </ul>
        <template v-if="section.paragraphs_after">
          <p
            v-for="(paragraph, idx) in section.paragraphs_after"
            :key="`pa-${idx}`"
          >
            {{ paragraph }}
          </p>
        </template>
        <ul v-if="section.list_after?.length">
          <li v-for="(item, idx) in section.list_after" :key="`lia-${idx}`">
            {{ item }}
          </li>
        </ul>
        <template v-if="section.paragraphs_final">
          <p
            v-for="(paragraph, idx) in section.paragraphs_final"
            :key="`pf-${idx}`"
          >
            {{ paragraph }}
          </p>
        </template>
        <ul v-if="section.list_final?.length">
          <li v-for="(item, idx) in section.list_final" :key="`lif-${idx}`">
            {{ item }}
          </li>
        </ul>
        <template v-if="section.paragraphs_final2">
          <p
            v-for="(paragraph, idx) in section.paragraphs_final2"
            :key="`pf2-${idx}`"
          >
            {{ paragraph }}
          </p>
        </template>
        <ul v-if="section.list_final2?.length">
          <li v-for="(item, idx) in section.list_final2" :key="`lif2-${idx}`">
            {{ item }}
          </li>
        </ul>
        <template v-if="section.paragraphs_end">
          <p
            v-for="(paragraph, idx) in section.paragraphs_end"
            :key="`pe-${idx}`"
          >
            {{ paragraph }}
          </p>
        </template>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  name: "DocsRules",
  mounted() {
    // Скрываем MainButton при переходе на эту страницу
    const tg = window.Telegram?.WebApp
    const mb = tg?.MainButton
    if (mb) {
      mb.hide()
    }
  },
  data() {
    return {
      sections: [
        {
          title: "1. Основные положения:",
          paragraphs: [
            "Данные Правила пользования профессиональной информационной ресейл - платформой «SNKRROOM» (Далее - Правила) регулируют взаимодействие Участников платформы (далее – Участники) и профессиональной информационной ресейл - платформой «SNKRROOM» (Далее – Платформа);",
            "Нарушение данных Правил может привести к блокировке аккаунта Участника.",
            "Соглашаясь с данными Правилами, Участник полностью и безоговорочно обязуется их соблюдать.",
            "Платформа имеет право изменять данные Правила в одностороннем порядке без личного уведомления Участников. Новая редакция Правил вступает в силу с момента ее публикации на Платформе, если иное не предусмотрено новой редакцией. Продолжение использования Платформы после публикации новой редакции означает согласие Участника с изменениями.",
            "Актуальная версия Правил находится в разделе «Документация» в личном кабинете Участника.",
          ],
        },
        {
          title: "1.1 Термины и определения:",
          paragraphs: [],
        },
        {
          title: "1.2",
          subtitle: "- Платформа:",
          paragraphs: [
            "Профессиональная онлайн-площадка, оказывающая Участникам услуги информационно-технологического характера, а также услуги по аутентификации и проведению безопасных сделок между Участниками Платформы за вознаграждение с помощью Telegram – облачного мессенджера для мобильных устройств и компьютеров.",
          ],
        },
        {
          title: "1.2.1",
          subtitle: "- Участники:",
          list: [
            "- Реселлер: Участник, осуществляющий намерение приобрести товар с помощью Платформы;",
            "- Селлер: Участник, размещающий информацию о своих товарах на Платформе с целью продажи;",
          ],
        },
        {
          title: "1.2.2",
          subtitle: "- Товар:",
          paragraphs: [
            "Предметы (кроссовки), которые Селлер готов передать Реселлеру на возмездной основе;",
          ],
          list: [
            "- Заявка: Оповещение Реселлером Селлера о намерении приобрести Товар;",
            "- Заказ: Процесс, следующий после подтверждения Заявки Селлером, заканчивающийся, либо не заканчивающийся завершением Сделки;",
            "- Сделка: Передача Товара Селлером Реселлеру, осуществлённая с помощью Платформы;",
            "- Удачно завершенная сделка: Сделка, завершённая без нарушений условий передачи, получения, оплаты и/или возврата Товара;",
            "- Аутентификация: Процесс проверки товара экспертами Платформы на соответствие описанию, подлинности и состоянию товара;",
            "- Пункт выдачи и аутентификации: Место аутентификации товаров, а также выдача товаров Селлеру или Реселлеру, расположенный по адресу: Московская область, Ленинский городской округ, Варшавское шоссе, 21-й километр, с26, помещение АД 14А;",
            "- Подделка (Реплика/Фейк): Товар, являющийся контрафактным и не произведенный правообладателем бренда;",
            "- Аккаунт: Учётные данные Участников, с помощью которых Участники осуществляют использование функционала Платформы;",
            "- Блокировка аккаунта: Временное или постоянное ограничение доступа Участника к функционалу Платформы за нарушение правил;",
            "- Служба поддержки: Специализированная служба Платформы, обеспечивающая взаимодействие с Участниками и решение спорных ситуаций и/или технических проблем, возникших на Платформе, связаться я с которой Участник может в личном кабинете;",
            "- Личный кабинет Участника: Специальный раздел приложения, предназначенный для авторизованных пользователей. В нём хранится персональная информация пользователя, а также различные настройки Аккаунта.",
            "- Политика обработки персональных данных: Документ, который описывает правила сбора, использования и защиты персональных данных Участников в соответствии с действующим законодательством Российской Федерации; С Политикой обработки персональных данных Платформы можно ознакомиться в личном кабинете Участника в разделе «Документация».",
          ],
        },
        {
          title: "2. Предмет Правил:",
          paragraphs: [
            "2.1. Платформа посредством специализированной интернет - площадки в Telegram - облачного мессенджера для мобильных устройств и компьютеров, оказывает Участникам услуги информационно-технологического характера. Платформа не является стороной договора купли-продажи, а лишь обеспечивает взаимодействие между Участниками посредством функционала Платформы.",
            "2.2. В соответствии с Правилами Платформа принимает на себя обязательство за вознаграждение посредством функционала Платформы:",
          ],
          list: [
            "2.2.1. Осуществлять размещение информации о Товарах;",
            "2.2.2. Осуществлять поиск Реселлеров для Селлеров и наоборот;",
            "2.2.3. Участвовать в расчетах между Участниками с помощью сервиса «Мультирасчёты» (https://www.tbank.ru/business/online-payments/multi-calculation-service/) с удержанием Платформой вознаграждения в размере и порядке, установленных п.9 настоящих Правил;",
            "2.2.4. Предоставить Платформу для Аутентификации Товара, в том числе организовать проведение Аутентификации сертифицированными специалистами Платформы;",
          ],
        },
        {
          title: "3. Услуги Платформы за вознаграждение:",
          paragraphs: [
            "3.1. Услугами Платформы за вознаграждение считаются услуги, предусмотренные п. 2.2. настоящих Правил.",
            "3.2. Участники обязуются оплачивать Платформе вознаграждение за услуги информационно – технологического характера согласно п. 9 настоящих Правил. Услуги информационно - технологического характера оказываются Участникам исключительно посредством функционала Платформы.",
            "3.3. Платформа имеет право отказать Участникам в предоставлении услуг.",
          ],
        },
        {
          title: "4. Регистрация и аккаунт:",
          paragraphs: [
            "4.1. Регистрируясь на Платформе, Участник подтверждает, что ему есть 14 (четырнадцать) полных лет на момент регистрации.",
            "4.2. В соответствии со ст. 437 ГК РФ, регистрируясь на Платформе, Участник полностью и безоговорочно принимает Правила Платформы.",
            "4.3. Регистрируясь на Платформе, Участник даёт согласие на обработку своих персональных данных, (Платформа входит в Реестр операторов персональных данных под № 77-25-522908. Приказ № 838 от 17.12.2025).",
            "4.4. Платформа проводит модерацию всех аккаунтов, желающих быть зарегистрированными на Платформе, и имеет право отказать в регистрации без объяснения причин.",
            "4.5. Все действия, совершенные с аккаунта Участника, считаются совершёнными самим Участником.",
            "4.6. Запрещено использование аккаунта третьими лицами без согласия владельца аккаунта. Ответственность за сохранность данных своего аккаунта несёт его владелец.",
            "4.7. За использование Платформы в противоправных целях следует немедленная блокировка аккаунта Участника без возможности его восстановления.",
          ],
        },
        {
          title: "5. Правила Платформы для Селлера:",
          paragraphs: [
            "5.1. Селлер, размещающий информацию о своих Товарах на Платформе, обязан обеспечить наличие, подлинность, а также потребительские качества товара. В случае, если в процессе аутентификации Товар не пройдёт проверку подлинности Платформой, данный Товар будет возвращён Селлеру за его счёт либо утилизирован, а аккаунт Селлера на Платформе может быть заблокирован.",
            "5.2. Селлер размещает свои Товары по шаблону, предоставленному Платформой. Также возможно добавление Товара вручную. Каталог Селлера проходит модерацию Платформой.",
            "5.3. Для начала работы на Платформе минимальное количество размещаемого Селлером товара должно быть не менее 10 (Десяти) пар.",
            "5.4. Сделка с Реселлером начинается с создания Реселлером заявки на приобретение Товара Селлера.",
            "5.5. Селлер обязан либо принять, либо отклонить заявку Реселлера на приобретение Товара в течение 60 минут с момента оповещения Платформой Селлера о поступлении ему новой заявки.",
            "5.6. Отклоняя заявку, Селлер указывает предложенную Платформой причину отклонения заявки.",
            "5.7. Подтверждая заявку, Селлер принимает предложение Реселлера о продаже своего Товара по окончательной стоимости (если таковая не будет изменена по согласованию Участников). Окончательной стоимостью товара является та, которую Селлер устанавливает для оплаты Реселлером.",
            "5.8. Селлер обязуется отслеживать ход сделки по статусам:",
          ],
          list: [
            "- Новая заявка, подтвердите (Реселлер создал заявку на приобретение Товара. У Реселера. У Селлера есть 60 минут, чтобы подтвердить заявку);",
            "- Заказ ожидает оплату (Реселлер должен оплатить заказ в течение 30 минут с момента принятия заявки Селлером);",
            "- Заказ оплачен, доставьте Товар в пункт выдачи и аутентификации (Селлер обязан доставить Товар по заказу в пункт выдачи и аутентификации Платформы в течение времени, указанного при регистрации на Платформе);",
            "- Заказ в пункте выдачи, аутентификация начата (Товар получен Платформой, происходит процесс аутентификации);",
            "- Заказ готов к выдаче (Заказ готов к выдаче Реселлеру)",
            "- Заказ выдан Реселлеру (Реселлер получил свой Товар по заказу)",
            "- Сделка завершена (Реселлер выкупил Товар по заказу. Деньги будут перечислены Селлеру).",
          ],
          paragraphs_after: [
            "5.9. Для каждого этапа сделки Платформой отводится определённый отрезок времени. Количество оставшегося времени отслеживается с помощью таймера.",
            "5.10. Селлер обязан привязать банковскую карту на своё в личном кабинете Платформы для проведения расчётов.",
            "5.11. Денежные средства перечисляются на банковскую карту Селлера с учётом вознаграждения Платформы.",
            "5.12. Услуги пользования Платформой оказываются Селлеру за вознаграждение.",
            "5.13. Размещая Товар на платформе, Селлер подтверждает, что является владельцем Товара и готов продать его Реселлеру по указанной стоимости.",
            "5.14. Селлер обязан предоставить Товар, оплаченный Реселлером, для аутентификации путём передачи товара Платформе в течение времени отправки, выбранного при регистрации на Платформе.",
            "5.15. Селлер передаёт Товар в пункт выдачи и аутентификации, а Платформа принимает его, сопровождая Универсальным передаточным документом по форме ТОРГ-12.",
            "5.16. Если Товар Селлера не проходит аутентификацию, он возвращается Селлеру. Правила хранения такого Товара указаны в «Правила хранения товара», размещённых в разделе «Документация» в личном кабинете Селлера.",
            "5.17. В случае возникновения спорных вопросов по сделке Селлер имеет право обратиться в службу поддержки Платформы.",
          ],
        },
        {
          title: "6. Правила Платформы для Реселлера:",
          paragraphs: [
            "6.1. Сделка с Селлером начинается с создания Реселлером заявки на приобретение Товара Селлера.",
            "6.2. Создавая заявку, Реселлер делает Селлеру предложение приобрести Товар по указанной Селлером окончательной стоимости (если таковая не будет изменена по согласованию Участников).",
            "6.3. Перед созданием заявки, Реселлер обязан внимательно ознакомиться с информацией, указанной в карточке Товара, который он хочет приобрести.",
            "6.4. Для каждого этапа сделки Платформой отводится определённый отрезок времени. Количество оставшегося времени отслеживается с помощью таймера.",
            "6.5. Реселлер обязан отслеживать ход сделки по статусам:",
          ],
          list: [
            "- Заявка создана, ожидайте подтверждения (Селлер должен принять или отклонить заявку);",
            "- Заявка подтверждена, оплатите заказ (Реселлеру нужно оплатить свой заказ);",
            "- Заказ оплачен, Селлер должен доставить товар по заказу в пункт выдачи и аутентификации (Селлер должен доставить Товар по заказу в пункт выдачи и аутентификации);",
            "- Заказ в пункте выдачи, аутентификация начата (Товар Селлера принят Платформой для аутентификации);",
            "- Заказ готов к выдаче (Реселлер может забрать Товар по заказу);",
            "- Заказ выдан Реселлеру (Реселлер получил свой заказ);",
            "- Сделка завершена (Реселлер выкупил Товар по заказу, деньги перечислены Селлеру);",
          ],
          paragraphs_after: [
            "6.6. Получение оплаченного Реселлером Товара осуществляется лично им самим, либо доставкой силами Платформы за счёт Реселлера, выбранным им способом доставки. Ответственность за предоставленные для доставки данные несёт Реселлер.",
            "6.7. Реселлер обязан получить (забрать) или вернуть (если потребуется) оплаченный им Товар по заказу в соответствии с п.7 настоящих Правил.",
            "6.8. Реселлер может завершить сделку досрочно после получения товара, если возврат Товара не требуется. В таком случае сделка будет считаться завершённой, а денежные средства будут перечислены Селлеру.",
            "6.9. Реселлер имеет право отказаться от заказа до получения им статуса «Заказ в пункте выдачи, аутентификация начата», а также «Заказ готов к выдаче». Если Реселлер отменит заказ после получения им данных статусов, сделка будет завершена Платформой, а с Реселлера удержится вознаграждение за услуги Платформы в размере 15% от стоимости заказа.",
            "6.10. Если сделка завершена Реселлером с нарушениями условий отмены заказа, получения и/или возврата Товара по заказу, указанных в п.7 настоящих Правил, денежные средства возвращаются Реселлеру с удержанием вознаграждения за услуги Платформы в размере 15% от стоимости заказа.",
            "6.11. В случае возникновения спорных вопросов по сделке Реселлер имеет право обратиться в службу поддержки Платформы.",
          ],
        },
        {
          title: "7. Правила получения и возврата Товара Реселлером:",
          paragraphs: [
            "7.1. Получение Товара по заказу Реселлером возможно после того, как статуса заказа изменится на «Заказ готов к выдаче» в личном кабинете Реселлера.",
            "7.2. После присвоения заказу статуса «Заказ готов к выдаче», у Реселлера обязан в течение 48 часов получить и вернуть Товар (в случае необходимости). По истечению времени на возврат Товара, сделка завершится автоматически, а оплата за заказ перечислится Селлеру.",
            "7.3. Если Реселлер не получил Товар в течение 48 часов с момента присвоения заказу статуса «Заказ готов к выдаче», сделка завершится автоматически, денежные средства будут перечислены Селлеру.",
            "7.4. Возврат Товара возможен в следующих случаях, если:",
          ],
          list: [
            "- При осмотре Реселлером Товара в момент его получения обнаружено расхождение с заказываемым Реселлером Товаром;",
            "- Отсутствуют следы носки, повреждения Товара.",
            "- Не нарушена целостность защитной пломбы и сертификат аутентификации, принадлежащий данному Товару, имеется в наличии.",
            "- В наличии имеется весь комплект дополнительных аксессуаров, если таковые имелись у Товара при получении его Реселлером;",
            "- Не нарушен срок возврата;",
          ],
          paragraphs_after: [
            "7.5. После присвоения заказу статуса «Заказ готов к выдаче» хранение Товара Реселлера в пункте выдачи и аутентификации осуществляется в соответствии с «Правилами хранения Товара», размещённых в разделе «Документация» в личном кабинете Реселлера.",
            "7.6. В случае нарушения условий возврата Товара (п. 7.4), денежные средства, оплаченные за данный Товар, не подлежат возврату Реселлеру.",
          ],
        },
        {
          title: "8. Аутентификация Товара:",
          paragraphs: [
            "8.1. Все Товары по заказам, перед получением их Реселлером, проходят обязательную аутентификацию в специализированном Пункте выдачи и аутентификации Платформы сертифицированными специалистами. Аутентификация Товара может длиться до 24 часов.",
            "8.2. Процесс аутентификации включает в себя:",
          ],
          list: [
            "а) проверку подлинности всех элементов Товара;",
            "б) оценку состояния и соответствия заявленному описанию;",
            "в) фотофиксацию.",
          ],
          paragraphs_after: [
            "Методы аутентификации определяются внутренними стандартами Платформы. Платформа не несет ответственности за скрытые дефекты, не выявленные в ходе визуального осмотра.",
            "8.3. Результаты аутентификации являются окончательными и могут быть оспорены Реселлером после получения оплаченного им Товара только по предоставлению независимого экспертного заключения аккредитованным центром о том, что Товар является контрафактным (поддельным). В таком случае Платформа осуществляет возврат денежных средств, оплаченных Реселлером за данный товар, в полном объёме. Также Платформа возмещает Реселлеру затраты на проведённую экспертизу.",
            "8.4. В случае прохождения аутентификации, к товару прикрепляется специальная защитная пломба, с QR –кодом, в котором содержится информация о товаре, а также о результатах аутентификации. Информация о защитной пломбе и сертификате находится в разделе «Документация». Также к товару прилагается сертификат аутентификации с номером проверки и идентичным QR – кодом, что и на защитной пломбе.",
          ],
        },
        {
          title: "9. Вознаграждение Платформы:",
          paragraphs: [
            "9.1. После удачном завершения сделки, Платформа удерживает с Селлера вознаграждение за услуги Платформы в размере 15% от стоимости заказа.",
            "9.2. Платформа удерживает вознаграждение с Реселлера при нарушении им условий отмены заказа, получения и/или возврата Товара, предусмотренные в п.п. 6.9., 6.10 настоящих Правил за услуги, предусмотренные п. 3.1. настоящих Правил.",
          ],
        },
        {
          title: "10. Порядок расчётов и безопасность сделок:",
          paragraphs: [
            "10.1. Все расчёты между Участниками осуществляются в российских рублях.",
            "10.2. Платформа не несёт ответственность за корректное предоставление данных банковских карт Участников и не хранит данные банковских карт Участников.",
            "10.3. Все финансовые обязательства по налогообложению Участников, если таковые возникают, берут на себя Участники. Платформа не является налоговым агентом по доходам Участников, полученным в результате совершения сделок на Платформе, и не производит исчисление, удержание и перечисление НДФЛ. Участники самостоятельно несут ответственность за соблюдение налогового законодательства.",
            "10.4. Расчёты между Участниками, равно как и безопасность этих расчётов, осуществляются с помощью сервиса «Мультирасчёты» (https://www.tbank.ru/business/online-payments/multi-calculation-service/). Платформа не осуществляет прямых расчётов между Участниками, а является только техническим посредником в осуществлении сделок.",
            "10.5. Расчёты на Платформе осуществляются следующим образом:",
          ],
          list: [
            "- Реселлер оплачивает товар.",
            "- Сервис «Мультирасчёты» «замораживает» (холдирует) деньги Реселлера на специальном счёте.",
            "- При удачном завершении сделки денежные средства перечисляются на банковскую карту Селлера.",
            "- Если заказ отменён Селлером после присвоения заказу статуса «Заказ оплачен, доставьте Товар в пункт выдачи и аутентификации», денежные средства, оплаченные Реселлером за заказ, возвращаются Реселлеру в полном объёме.",
          ],
        },
        {
          title: "11. Разрешение споров:",
          paragraphs: [
            "11.1. При возникновении споров, претензий или иных вопросов, Участники имеют право обратиться в службу поддержки Платформы через личный кабинет Участника, а также обратиться по адресу электронной почты info@snkrroom.ru.",
            "11.2. Для разрешения споров по заказам (сделкам) Участнику необходимо предоставить все детали заказа (сделки).",
            "11.3. Все споры между Участниками и/или Платформой, разрешаются путём переговоров. В случае невозможности разрешения споров путём переговоров, Участники и/или Платформа имеют право разрешать споры во внесудебном и/или судебном порядке.",
          ],
        },
        {
          title: "12. Рейтинги участников:",
          paragraphs: [
            "12.1. Каждый Участник имеет свой рейтинг, который складывается из определённых действий Участников. Рейтинг может изменяться как в положительную, так и отрицательную стороны.",
            "12.2. Рейтинг является автоматизированным инструментом и не может гарантировать абсолютную надежность Участника.",
            "12.3. На изменение рейтинга Селлера в положительную сторону влияет:",
          ],
          list: [
            "- Количество успешно завершённых сделок;",
            "- Количество Товаров, размещённых на Платформе;",
            "- Своевременная, либо раньше установленного срока доставка Товара в Пункт выдачи и аутентификации;",
            "- Дата регистрации Селлера на Платформе.",
            "- Количество положительных отзывов;",
          ],
          paragraphs_after: [
            "12.3.1. На изменение рейтинга Селлера в отрицательную сторону влияет:",
          ],
          list_after: [
            "- Отмены заявок Реселлеров по разным причинам (кроме причины «Не подходит цена»);",
            "- Бездействие Селлера при получении им заявок в течение 60 минут с момента уведомления о них;",
            "- Отмены заказов;",
            "- Задержки при доставке Товаров по заказам в пункт выдачи и аутентификации;",
            "- Случаи, когда Товары Селлера не проходят аутентификацию;",
            "- Количество отменённых сделок;",
            "- Количество отрицательных отзывов;",
          ],
          paragraphs_final: [
            "12.4. На изменение рейтинга Реселлера в положительную сторону влияет:",
          ],
          list_final: [
            "- Количество заказов;",
            "- Количество выкупленных позиций Товара;",
            "- Количество досрочно завершённых удачных сделок;",
          ],
          paragraphs_final2: [
            "12.4.1. На изменение рейтинга Реселлера в отрицательную сторону влияет:",
          ],
          list_final2: [
            "- Отмена заказов после подтверждения Селлером заявок Реселлера;",
            "- Количество платных хранений Товара;",
            "- Отмены заказов по причине их несвоевременной оплаты;",
            "- Количество возвратов Товара;",
            "- Количество отменённых заказов после получения ими статуса «Заказ готов к выдаче»;",
          ],
          paragraphs_end: [
            "12.5. Платформа оставляет за собой право изменять алгоритм расчета рейтинга.",
          ],
        },
        {
          title: "13. Правила торга:",
          paragraphs: [
            "13.1. На платформе предусмотрена возможность торга за товары Селлеров. Возможность торга даёт Селлеру больше возможностей продать Товар, а Реселлеру купить его по наиболее выгодной для него стоимости.",
            "13.2. Реселлеры могут предлагать свою цену за товар. Селлеры могут включать эту опцию по своему усмотрению. Также по своему усмотрению Селлер вправе отказаться от цены, предложенной Реселлером и продавать Товар по заранее установленной цене.",
            "13.3. Для того, чтобы торговаться за Товар, Реселлеру необходимо предложить свою цену при создании заявки путём выбора опции торга.",
            "13.4. Если Селлера устроит предложенная Реселлером цена, начнётся процесс оформления заказа.",
            "13.5. Селлер вправе отказаться от предложенной Реселлером цены по причине «Не подходит цена».",
            "13.6. Селлер имеет право предложить свою цену в ответ, а Реселлер имеет право принять либо отклонить её. В таком случае Реселлеру нужно будет создать заявку с новой ценой, либо отменить текущую заявку.",
          ],
        },
        {
          title: "14. Отзывы и комментарии:",
          paragraphs: [
            "14.1. После завершения успешной сделки Участник Платформы обязан оставить комментарий о работе Платформы.",
            "14.2. Комментарий должны быть объективными и соответствовать действительности.",
            "14.3. Запрещено использование в комментариях нецензурной (ненормативной) лексики.",
          ],
        },
        {
          title: "15. Ответственность Участников Платформы:",
          paragraphs: [
            "15.1. Участники несут полную самостоятельную ответственность за все действия на Платформе. Любые противоправные действия на Платформе запрещены Участниками в любом виде.",
            "15.2. Запрещен сговор. Любые попытки манипулирования ценами, искусственного завышения или занижения стоимости в сговоре с другими пользователями строго запрещены.",
            "15.3. Запрещен обман. Введение других пользователей в заблуждение, мошеннические схемы. Попытки обойти правила Платформы недопустимы.",
            "15.4. Запрещено размещение на Платформе информации о поддельных (неоригинальных) товарах.",
            "15.5. Все товарные знаки (логотипы, эмблемы), представленные на Платформе, являются зарегистрированными товарными знаками и принадлежат правообладателям. Участникам запрещено использовать зарегистрированные товарные знаки (логотипы, эмблемы) без разрешения правообладателей, либо без иных законных оснований.",
            "15.6. Участники обязаны уважать друг друга. Запрещены оскорбления, угрозы, дискриминационные высказывания в любом виде.",
            "15.7. Во всех своих действия на Платформе Участники несут ответственность в соответствии с действующим Законодательством Российской Федерации.",
          ],
        },
        {
          title: "16. Форс - мажор",
          paragraphs: [
            "16.1. Участники и/или Платформа не будут нести ответственности за полное или частичное неисполнение своих обязательств, если неисполнение своих обязательств, является следствием наводнения, пожара, землетрясения, пандемии, эпидемии, и других стихийных бедствий или военных действий, возникших после принятия данных Правил.",
            "16.2. Если форс-мажор и его последствия продолжают действовать более 2-х месяцев, то Участники и/или Платформа имеют право отказаться от дальнейшего исполнения обязательств по соблюдению данных Правил. В этом случае Участники и/или Платформа не имеют права на требование возмещения возможных убытков.",
            "16.3. Во всех остальных случаях, не предусмотренных настоящими Правилами, Участники и/или Платформа несут ответственность, предусмотренную действующим законодательством РФ.",
          ],
        },
        {
          title: "17. Контактные данные платформы",
          paragraphs: [
            "17.1. Индивидуальный предприниматель Сукач Олег Ювенальевич. ОГРНИП: 325774600661532. Адрес электронной почты: snkrroomru@gmail.com.",
          ],
        },
      ],
    }
  },
}
</script>

<style lang="scss" module>
.wrapper {
  padding: 1.25rem 1rem 6rem 1rem;
}

.header {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 1rem;
}

.headerLabel {
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9b9ba1;
  margin: 0 0 0.15rem 0;
}

.header h1 {
  font-size: 1.5rem;
  line-height: 1.2;
  margin: 0;
}

.meta {
  background: #f5f7fa;
  border-radius: 0.75rem;
  padding: 1rem;
  font-size: 0.95rem;
  color: #4b4d52;
  margin-bottom: 1.25rem;
}

.meta p {
  margin: 0 0 0.5rem 0;
}

.meta p:last-child {
  margin-bottom: 0;
}

.article {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.section {
  border: 1px solid #ebeaea;
  border-radius: 0.75rem;
  padding: 1rem;
  background: #fff;
}

.section h2 {
  margin: 0 0 0.5rem 0;
  font-size: 1.05rem;
}

.subtitle {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.section p {
  margin: 0 0 0.5rem 0;
  line-height: 1.45;
  color: #2c2d30;
}

.section ul {
  margin: 0;
  padding-left: 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  color: #2c2d30;
  line-height: 1.4;
}
</style>
